// src/player.js

export function createPlayer(k, state) {
    const {
        PLAYER_MAX_HP,
        ARENA_PADDING,
        HUD_HEIGHT,
    } = state.constants;

    const clamp = (value, min, max) => Math.max(min, Math.min(max, value));

    const player = k.add([
        k.sprite("player-avatar", { anim: "idle" }),
        k.pos(k.width() * 0.3, k.height() * 0.6),
        k.anchor("center"),
        k.area(),
        k.body(),
        k.scale(1.65),
        k.z(5),
        {
            hp: PLAYER_MAX_HP,
            canPunch: true,
            cooldownTimer: 0,
            specialReady: true,
            specialCooldownTimer: 0,
        },
        "player",
    ]);

    const playerShadow = k.add([
        k.rect(54, 18, { radius: 9 }),
        k.pos(player.pos.x, player.pos.y + 20),
        k.anchor("center"),
        k.color(0, 0, 0),
        k.opacity(0.28),
        k.z(4),
    ]);

    player.hidden = true;
    playerShadow.hidden = true;
    
    function getSpeed() {
        let speed = state.constants.SPEED;
        if (state.activePowerUp === "speed") {
            speed *= state.constants.POWERUP_SPEED_MULTIPLIER;
        }
        return speed;
    }

    player.onUpdate(() => {
        if (state.menuActive) return;
        const halfW = (player.width ?? 32) / 2;
        const halfH = (player.height ?? 32) / 2;
        const minX = ARENA_PADDING + halfW;
        const maxX = k.width() - ARENA_PADDING - halfW;
        const minY = HUD_HEIGHT + 30 + halfH;
        const maxY = k.height() - ARENA_PADDING - halfH;

        player.pos.x = clamp(player.pos.x, minX, maxX);
        player.pos.y = clamp(player.pos.y, minY, maxY);
        playerShadow.pos = k.vec2(player.pos.x, player.pos.y + 20);
    });

    k.onKeyDown("left", () => {
        if (state.menuActive || state.gameOver) return;
        player.move(-getSpeed(), 0);
        state.playerFacing = k.vec2(-1, 0);
        state.spawnDashSmoke(player.pos, k.vec2(-1, 0));
    });

    k.onKeyDown("right", () => {
        if (state.menuActive || state.gameOver) return;
        player.move(getSpeed(), 0);
        state.playerFacing = k.vec2(1, 0);
        state.spawnDashSmoke(player.pos, k.vec2(1, 0));
    });

    k.onKeyDown("up", () => {
        if (state.menuActive || state.gameOver) return;
        player.move(0, -getSpeed());
        state.playerFacing = k.vec2(0, -1);
        state.spawnDashSmoke(player.pos, k.vec2(0, -1));
    });

    k.onKeyDown("down", () => {
        if (state.menuActive || state.gameOver) return;
        player.move(0, getSpeed());
        state.playerFacing = k.vec2(0, 1);
        state.spawnDashSmoke(player.pos, k.vec2(0, 1));
    });

    return { player, playerShadow };
}